/**
 * Settings Page
 *
 * Displays:
 * - User Settings
 * - Tenant Settings (if Admin)
 */

import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { showToast } from '../utils/toast';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

export const Settings: React.FC = () => {
  const { user } = useAuth();
  const [isSaving, setIsSaving] = useState(false);

  const isAdmin = user?.role === 'admin' || user?.role === 'owner';

  const handleSave = async () => {
    setIsSaving(true);

    try {
      // TODO: Backend API call implementation needed
      // await apiClient.updateSettings({ ... });

      // Mock for now
      await new Promise(resolve => setTimeout(resolve, 1000));

      showToast.success('Settings saved successfully');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to save settings';
      showToast.error(message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">Settings</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Manage your account and tenant settings
          </p>
        </div>

        <div className="space-y-6">
          {/* User Settings */}
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">User Settings</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={user?.email || ''}
                  disabled
                  className="disabled:bg-muted disabled:text-muted-foreground"
                />
                <p className="text-sm text-muted-foreground">
                  Email cannot be changed
                </p>
              </div>
              <div className="space-y-2">
                <Label htmlFor="role">Role</Label>
                <Input
                  type="text"
                  id="role"
                  name="role"
                  value={user?.role || ''}
                  disabled
                  className="disabled:bg-muted disabled:text-muted-foreground"
                />
              </div>
            </CardContent>
          </Card>

          {/* Tenant Settings (Admin only) */}
          {isAdmin && (
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Tenant Settings</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="tenantName">Tenant Name</Label>
                  <Input
                    type="text"
                    id="tenantName"
                    name="tenantName"
                    placeholder="Enter tenant name"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="n8nUrl">n8n URL</Label>
                  <Input
                    type="url"
                    id="n8nUrl"
                    name="n8nUrl"
                    placeholder="https://n8n.example.com"
                  />
                </div>
              </CardContent>
            </Card>
          )}

          {/* Save Button */}
          <div className="flex justify-end">
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save Settings'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};













